import { IUser } from 'types'
import { callApi, ENDPOINTS } from 'utils/api/callApi'

interface IGetDriversRequest {
  carrierId: number
}

interface IGetDriversResponse {
  users: IUser[]
}

/**
 * Fetches carrier's list of drivers
 */
const getDrivers = ({ carrierId }: IGetDriversRequest): Promise<IGetDriversResponse> =>
  callApi({
    params: {
      // TODO: This can be further abstracted for user fetch endpoint
      filters: {
        carrierId,
        userType: ['owner_operator', 'driver'],
        status: 'approved',
      },
      perPage: 1000,
    },
    endpoint: ENDPOINTS.users,
  })

export default getDrivers
